module.exports = __webpack_public_path__ + "static/img/8.0ebe09f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/8.png
// module id = 2BHS
// module chunks = 0